import { ApplicationMode, ApplicationModes, QuestionnaireEngineConfig } from '@zinnia/form-engine-sdk';

import { PlatformFeatures } from '../Models/PlatformFeatures';

// This helper can be used for extending questionnaire engine config
export function getQuestionnaireEngineConfig(
  mode: ApplicationMode,
  features: PlatformFeatures,
  outputConfig?: QuestionnaireEngineConfig,
) {
  const config: QuestionnaireEngineConfig = {
    logUnexpectedAnswers: false,
    logValidationErrors: false,
    ...(outputConfig ?? {}),
  };

  if (features.questionnaireScreen?.enabled && mode === ApplicationModes.paper) {
    config.screenConfig = features.questionnaireScreen?.config?.PaperApp;

    if (!config.screenConfig) {
      throw new Error('The config for the questionnaireScreen feature wasn`t provided.');
    }
  }

  return config;
}
